module.exports = __webpack_public_path__ + "img/sol.b27f9d1c.png";